module.exports = __webpack_public_path__ + "img/Modal2_BackgroundMesh.svg";